/* template */
<template><drawer-bottom :show="(show)" :title="(title)" @close="close" showDefaultNav class="main"><div class="container"><Tab :style='["marginBottom: 10px"] | transRpxStyle' :tabKey="(curTrainNo)" :tabList="(tabList)" @settabkey="setStayInfo" v-if="(isTransfer)"/><station-stay-info :stayInfo="(stayInfo)" :style='["height:100%;"] | transRpxStyle' v-if="(show)"/></div></drawer-bottom></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m20921e4e"}'>
.main
  /deep/ .header
    color #222
    line-height 1
    font-weight 400
    .drawer-title
      font-size 16px
      line-height 16px
      text-align center
  .container
    display flex
    flex-direction column
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m20921e4e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./stay-info-drawer.mpx.js?isComponent&outputPath=components%2Fstay-info-drawer20921e4e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./stay-info-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fstay-info-drawer20921e4e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m20921e4e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/stay-info-drawer20921e4e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Tab':getComponent(require("./tab.mpx?isComponent&outputPath=components%2Ftab6186cc86%2Findex")),'drawer-bottom':getComponent(require("../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'station-stay-info':getComponent(require("./station-stay-info/index.mpx?isComponent&outputPath=components%2Findexe1125406%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
